<template>
  <header id="header" class="header-nav fixed-top">
    <div class="container align-items-center">
      <nav class="navbar navbar-expand-lg navbar-light">
        <router-link to="/">
          <img style="max-height: 50px" src="assets/logo/logo_white.png" alt="winfin">
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="javascript:" v-scroll-to="'#topup'">Recharge Now</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:" v-scroll-to="'#packages'">Recharge Offers</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:" v-scroll-to="'#how-to-recharge'">How To Recharge</a>
            </li>
            <li class="nav-item become-partner">
              <a class="nav-link" href="javascript:" v-scroll-to="'#corporate'">Corporate Top-Up</a>
            </li>
            <li class="nav-item" v-if="!loginStatus">
              <a class="nav-link login-logout" @click="openModal" target="_blank">Sign In / Sign Up</a>
            </li>
            <li class="nav-item dropdown" v-else>
              <a href="javascript:" class="nav-link dropdown-toggle login-logout" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="icofont-ui-user"></i>
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item client-name" href="javascript:">{{authUser.client_name}}</a>
<!--                <a class="dropdown-item" href="javascript:">Profile</a>-->
                <router-link to="/topup-history" v-if="!isGuest">
                  <a class="dropdown-item" href="javascript:">Top-Up History</a>
                </router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:" @click="logout">Logout</a>
              </div>
            </li>
            <li class="nav-item mob-ml-5">
              <a class="nav-link login" :href="this.loginUrl" target="_blank">Client Portal</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
  <!-- End Header -->
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
export default {
  name: "Header",
  data() {
    return {
      localStatus: false,
    }
  },
  created() {
    let accessToken = localStorage.getItem('access_token');
    console.log(accessToken)
    if (accessToken != null && accessToken != "") {
      this.localStatus = true;
      this.$store.commit('loginStatus',true);
      this.getData(accessToken);
    } else {
      this.localStatus = false;
      this.$store.commit('loginStatus',false);
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus
    },
    authUser() {
      return this.$store.state.authUser
    },
    isGuest() {
      return this.$store.state.isGuest
    }
  },
  methods: {
    openModal() {
      this.$store.commit('showModal', true);
    },
    logout() {
      localStorage.removeItem("access_token");
      this.$store.commit("loginStatus", false);
      this.$toaster.success('Logged out successfully.')
      window.location.href = '/';
    },
    getData(accessToken) {
      let instance = this;
      axios.get(`${this.apiPath}get-client-data/${accessToken}`).then(function (response){
        instance.$store.dispatch('setUser',response.data.data);
      }).catch(function (error){
        let random_str = 'guest_'+Math.floor(Math.random() * 10000)+10;
        instance.$store.dispatch('setUser',{
          client_name: 'Guest',
          client_username: random_str,
          receive_time: '',
          status: 'Active',
          user_email: instance.email
        });
        instance.$store.commit('isGuest',true);
      });
    },
  }
};
</script>

<style scoped lang="scss">
.become-partner {
  margin-right: 30px;
}

.nav-item a {
  font-size: 12px !important;
  font-weight: bold;
  color: #ffffff !important;
}

.nav-item .dropdown-item {
  color: #004a59 !important;
}

.nav-item .dropdown-item:nth-child(1),.nav-item .dropdown-item:nth-child(2),.nav-item .dropdown-item:nth-child(3) {
  color: #585858 !important;
}

.nav-item .login {
  padding: 5px 15px;
  border-radius: 5px;
  color: #004a59 !important;
  background: #ffffff;
  cursor: pointer;
  border: 1px solid #004a59;
}

.nav-item .login-logout {
  padding: 5px 15px;
  border-radius: 5px;
  color: #FFFFFF !important;
  background: #8f2d56;
  cursor: pointer;
  border: 1px solid #8f2d56;
}

.navbar-light .navbar-nav .login:hover {
  color: #FFFFFF !important;
  background: #004a59;
}

.navbar-light .navbar-nav .login-logout:hover {
  color: #FFFFFF !important;
  background: #004a59;
  border: 1px solid #004a59;
}

.navbar-light .navbar-nav .login:focus {
  color: #004a59 !important;
  background: #ffffff;
}

.mob-ml-5 {
  margin-left: 5px;
}

.client-name {
  color: #2d2d2d !important;
}

@media (max-width: 768px) {
  #navbarSupportedContent {
    margin-top: 15px !important;
  }
  .login-logout {
    margin-bottom: 10px;
  }
  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
  }
  .navbar-toggler {
    border-color: rgb(255, 255, 255);
  }
  .mob-ml-5 {
    margin-left: 0;
  }
  .nav-item .dropdown-item {
    color: #004a59 !important;
  }
}
</style>
